import {ISelectOption} from '@pluto-tv/assemble';
import {orderBy} from 'lodash-es';
import {IDevice} from 'models/devices';

const orderByLabel = valueToMap => {
  return orderBy(
    valueToMap.map(label => ({label, value: label})),
    ['label'],
  );
};

const getPlatforms = (deviceTypesList: IDevice[]): ISelectOption[] => {
  return orderByLabel([...new Set(deviceTypesList.map(d => d.platform))]);
};

const getFilteredDeviceIncludedList = (deviceTypesList: IDevice[], devicesExcluded: string[]): ISelectOption[] => {
  const deviceIncludedOptionList = getPlatforms(deviceTypesList);
  return orderByLabel(deviceIncludedOptionList.flatMap(a => a.label).filter(i => !devicesExcluded?.includes(i)));
};

const getFilteredDeviceExcludedList = (deviceTypesList: IDevice[], devicesIncluded: string[]): ISelectOption[] => {
  const deviceExcludedOptionList = getPlatforms(deviceTypesList);
  return orderByLabel(deviceExcludedOptionList.flatMap(a => a.label).filter(i => !devicesIncluded?.includes(i)));
};

export {getPlatforms, getFilteredDeviceIncludedList, getFilteredDeviceExcludedList};
